import { html, ifDefined } from "../../.."
import { T } from "../../../textapi"
import { FieldSetVal } from "../fieldapi"

import { _setFieldFocus } from "../helper"
import { _focusOutHelper } from "./helpers"
import { SYSControlBase } from "./syscontrolbase"

export class SYSTextArea extends SYSControlBase {
  async handleInput(e: KeyboardEvent) {
    this.actions.ovl.form._ChangeField({
      fieldKey: this.field.fieldKey,
      formState: this.formState,
      value: this.inputElement.value,
      isInnerEvent: true,
      watched: true,
      noRetrigger: true,
    })
  }
  // change is important for eg. autofilled form inputs
  handleChange(e: Event) {
    this.field._state.valueChangedHandled = true
    this.actions.ovl.form._ChangeField({
      fieldKey: this.field.fieldKey,
      formState: this.formState,
      value: this.inputElement.value,
      isInnerEvent: false,
      watched: true,
      noRetrigger: true,
    })
  }

  async getUI() {
    let visible = super.InitControl()
    if (visible === false) {
      return undefined
    }

    let field = this.field
    let readonly = this.getReadOnly()

    let nullClicker = html`<span></span>`
    let isNullInput = ""
    if (field.nullHandling.enabled && field.convertedValue !== null) {
      isNullInput = "ovl-null-input"
      nullClicker = html`
        <span
          title="${T("SYSSetToNull")}"
          class="sap-icon--sys-cancel-2"
          role="presentation"
          @click=${(e) => FieldSetVal(field, null, { watched: true })}
        ></span>
      `
    }

    return html`
      <div
        class="${this.getContainerClass(
          "textarea",

          this.customInfo.customRowClassContainerName
        )}"
      >
        <ovl-controllabel .props=${() => this.field}> </ovl-controllabel>
        <div class=${`ovl-formcontrol-value ${isNullInput}`}>
          <textarea
            .value=${field.value}
            placeholder=${ifDefined(
              this.field.ui.infoValue ? this.field.ui.infoValue : undefined
            )}
            tabindex=${ifDefined(!this.focusable ? "-1" : undefined)}
            @input=${(e) => this.handleInput(e)}
            @change=${(e) => this.handleChange(e)}
            // @focusout=${(e) => {
              //   // see explanation on textbox. it should be the same there
              //   if (
              //     (!field._state.valueChangedHandled &&
              //       field._state.valueAfterGotFocus !== field.value) ||
              //     !field.previousValid
              //   ) {
              //     this.actions.ovl.form._ChangeField({
              //       fieldKey: this.field.fieldKey,
              //       formState: this.formState,
              //       value: this.inputElement.value,
              //       watched: true,
              //       noRetrigger: true,
              //     })
              //   }
              _focusOutHelper(e, this.field)
            }}
            @focus=${() => {
              this.field._state.valueAfterGotFocus = field.value
              this.field._state.valueChangedHandled = false
              _setFieldFocus(this.field, true)
            }}
            class=${`fd-textarea  __inpfocbox ${this.getInputClass(
              "textarea",

              this.customInfo.customRowClassName
            )}`}
            id=${field.id}
            spellcheck=${`${field.ui.useSpellcheck ? "true" : "false"}`}
            ?readonly=${readonly}
            autocomplete="new-password"
            name="search_ios_autocomplete_hack"
          ></textarea>
          ${nullClicker}
        </div>

        <ovl-controlcustomhint .props=${() => this.field}>
        </ovl-controlcustomhint>
        <ovl-controlvalidationhint .props=${() => this.field}>
        </ovl-controlvalidationhint>
      </div>
    `
  }
  async afterRender() {
    this.inputElement = document.getElementById(this.field.id)
    if (this.inputElement) {
      this.inputElement.value = this.field.value
    }
    await super.afterRender()
  }
}
